import classNames from "classnames";
import css from './kpo-bar.module.scss';

import kpoSrc from '../../assets/kpo/kpo.webp';
import rpSrc from '../../assets/kpo/rp.webp';
import euSrc from '../../assets/kpo/eu.webp';

export function KPOBar() {
    return <div className={css.kpoBar}>
        <div className={classNames(css.list, css.kpoBar)}>
            <div className={classNames(css.logoContainer, css.kpo)}>
                <img src={kpoSrc} alt="Krajowy Plan Odbudowy" />
            </div>
            <div className={classNames(css.logoContainer, css.rp)}>
                <img src={rpSrc} alt="Rzeczpospolita Polska" />
            </div>
            <div className={classNames(css.logoContainer, css.eu)}>
                <img src={euSrc} alt="Sfinansowane przez Unię Europejską NextGenerationEU" />
            </div>
        </div>
    </div>
}
